import type { VersionedWording } from '@/lib/versioned-labels';
import { RULE_SETTINGS_NAME } from '@matter_extractor/shared';

/**
 * How the versioned layer names « Les règles » (vitrine.md section 5, issue
 * #192), everywhere it has to.
 *
 * A SINGLETON, like the texts of the noyaux and the models beside it: no list,
 * no card, no creation box, no retirement, no rename. The sentences of the
 * gestures it never offers are written anyway, in French and true - see
 * `model-settings-wording.tsx`.
 *
 * The prefixes are `regles`: every mark of the head is `regles-...`
 * (`regles-entete`, `regles-enregistrer`, `regles-historique-ouvrir`), which is
 * what `reglages-regles.spec.ts` and `screenshots-reglages-versionnes.mjs`
 * read, beside the lists' own `reglages-regle` and `reglages-garde-fou`.
 */
export const RULE_SETTINGS_WORDING: VersionedWording = {
  kind: 'rules',
  entity: 'regles',
  list: 'regles',
  noun: ['réglage des règles', 'réglages des règles'],
  newTitle: RULE_SETTINGS_NAME,
  createLabel: 'Écrire les règles',
  saveHintNew: 'Crée la v1.',
  draftStateNew: 'Aucune version encore.',
  // The rules and the guardrails travel together, and a session freezes the
  // version it starts on: the promise is about the sessions to come.
  developmentHint: (nextNumber) =>
    `Les sessions neuves joueront la v${nextNumber} ; les sessions en cours gardent la version qu’elles ont figée.`,
  subject: (name) => name,
  retirement: {
    panelTitle: 'Les règles ne se retirent pas',
    retiredTitle: 'Règles retirées',
    confirmLabel: 'Retirer les règles',
    panelHint: () => <>Un seul objet pour les règles globales et les garde-fous, sans retrait.</>,
    retiredHint: (_name, day) => <>Retirées le {day}.</>,
    warningTitle: () => 'Aucune session ne serait plus tenue par ces règles',
  },
  refusal: {
    nameTaken: 'Les règles portent un nom fixe.',
    nameTakenBy: () => 'Les règles portent un nom fixe.',
    retired: 'Les règles sont retirées.',
  },
};
